// Brand resolution. process.env.REACT_APP_BRAND is inlined by CRA at build
// time, so each Docker image is single-brand. Default = cashew.

export type BrandId = 'cashew' | 'hazel';

const raw = (process.env.REACT_APP_BRAND || 'cashew').toLowerCase();
export const BRAND: BrandId = raw === 'hazel' ? 'hazel' : 'cashew';

if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-console
  console.info(`[brand] active: ${BRAND} (REACT_APP_BRAND=${process.env.REACT_APP_BRAND || 'unset'})`);
}

const NAMES: Record<BrandId, string> = {
  cashew: 'cashew',
  hazel: 'Hazel',
};

const COLORS: Record<
  BrandId,
  { primary: string; primaryLight: string; soft: string }
> = {
  cashew: { primary: '#ab87ff', primaryLight: '#b29bff', soft: '#e0d6f8' },
  hazel: { primary: '#FF9300', primaryLight: '#FFB04D', soft: '#F0E3D2' },
};

export const BRAND_NAME = NAMES[BRAND];
export const BRAND_COLORS = COLORS[BRAND];

// Public-folder asset paths. Used by logos, favicons, manifest, etc.
export const brandAsset = (relativePath: string) =>
  `${process.env.PUBLIC_URL || ''}/branding/${BRAND}/${relativePath.replace(/^\//, '')}`;
